import React, { useState, useEffect } from "react";
import LabelImage from "../cards/image";
import Loader from "../loader/loader";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import MyVerticallyCenteredModal from "../imgUpload/modal";
import Select from "react-select";
import { NecStore } from "../../store/necStore";
import {
  getAllImages,
  getAppParams,
  createBranding,
  editBranding,
  getBranding,
  getImagesById,
  publishBranding,
} from "../../api/api";
import Button from "react-bootstrap/Button";
import ToolTip from "../tooltip/tooltip";
// import { UserLang } from "../../store/userStore";

const Branding = (props) => {
  const obj = {
    images: {
      application: "",
      createdBy: "",
      date: "",
      imageName: "",
      imagekey: "7c3b33e3ea0fad6532b3763896398d30",
    },
  };
  const objs = {
    mainLogo: "",
    footerLogo: "",
    iconLogo: "",
    appIcon: "",
    marketingLogo: "",
    tvLogo: "",
    chromeCastLogo: "",
    mobileLogo: "",
    mainDarkLogo: "",
    footerDarkLogo: "",
    tvDarkLogo: "",
    chromeCastDarkLogo: "",
    mobileDarkLogo: "",
  };
  const [modalShow, setModalShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const [allImage, setallImage] = useState([]);
  const [branding, setBranding] = useState(objs);
  const [fooLogo, setFoologo] = useState(obj);
  const [fooDarkLogo, setFooDarklogo] = useState(obj);
  const [tLogo, setTlogo] = useState(obj);
  const [tDarkLogo, setTDarklogo] = useState(obj);
  const [appIco, setAppIco] = useState(obj);
  const [mainLogo, setMainlogo] = useState(obj);
  const [mainDarkLogo, setMainDarklogo] = useState(obj);
  const [marLogo, setMarlogo] = useState(obj);
  const [ccLogo, setCclogo] = useState(obj);
  const [ccDarkLogo, setCcDarklogo] = useState(obj);
  const [mobLogo, setMoblogo] = useState(obj);
  const [mobDarkLogo, setMobDarklogo] = useState(obj);
  const [webicon, setWebicon] = useState(obj);
  const [brandCount, setBrandCount] = useState("");
  const [brandStatus, setBrandStatus] = useState(0);
  const role = NecStore.useState((s) => s.setting);
  // const lan = UserLang.useState((s) => s.lan);
  const [lan] = useState("ltr");
  const onChangeItem = async (value, evt) => {
    setBranding({
      ...branding,
      [evt.name]: value.id,
    });
    const temp_obj = {
      images: {
        application: "",
        createdBy: "",
        date: "",
        imageName: value.name,
        imagekey: value.key,
      },
    };

    evt.name === "mainLogo"
      ? setMainlogo(temp_obj)
      : evt.name === "footerLogo"
        ? setFoologo(temp_obj)
        : evt.name === "appIcon"
          ? setAppIco(temp_obj)
          : evt.name === "marketingLogo"
            ? setMarlogo(temp_obj)
            : evt.name === "tvLogo"
              ? setTlogo(temp_obj)
              : evt.name === "chromeCastLogo"
                ? setCclogo(temp_obj)
                : evt.name === "mobileLogo"
                  ? setMoblogo(temp_obj)
                  : evt.name === "mainDarkLogo"
                    ? setMainDarklogo(temp_obj)
                    : evt.name === "footerDarkLogo"
                      ? setFooDarklogo(temp_obj)
                      : evt.name === "tvDarkLogo"
                        ? setTDarklogo(temp_obj)
                        : evt.name === "chromeCastDarkLogo"
                          ? setCcDarklogo(temp_obj)
                          : evt.name === "mobileDarkLogo"
                            ? setMobDarklogo(temp_obj)
                            : setWebicon(temp_obj);
  };

  useEffect(() => {
    const brandingDetail = async () => {
      /* eslint-disable no-unused-vars */
      const result = await getBranding().then(
        (result) => {
          brandImage(result.data);
          setBranding(result.data);
          setLoading(false);
        },
        (error) => {
          const obj = {
            status: error.response.data.error.status,
            message: error.response.data.error.message,
          };
          setBrandCount(obj.message);
          setBrandStatus(obj.status);
        }
      );
      /* eslint-disable no-unused-vars */
    };

    const getImage = async () => {
      try {
        const appl = await getAllImages(200, 0);
        const images = appl.data.images;
        const opt = images.map((item) => ({
          value: item.imagekey,
          label: (
            <LabelImage
              url={getAppParams() + item.imagekey}
              name={item.imageName}
            ></LabelImage>
          ),
          key: item.imagekey,
          name: item.imageName,
          id: item._id,
        }));
        setallImage(opt);
        setLoading(false);
      } catch (error) {}
    };
    const brandImage = async (editing) => {
      const result = await getImagesById(editing.mainLogo).then(
        (result) => {
          setMainlogo(result.data);
          setLoading(false);
        },
        (error) => {}
      );

      const dresult = await getImagesById(editing.mainDarkLogo).then(
        (result) => {
          setMainDarklogo(result.data);
          setLoading(false);
        },
        (error) => {}
      );
      /* eslint-disable no-unused-vars */
      /* eslint-disable no-unused-vars */
      const resulted = await getImagesById(editing.footerLogo).then(
        (result) => {
          setFoologo(result.data);
          setLoading(false);
        },
        (error) => {}
      );
      const dresulted = await getImagesById(editing.footerDarkLogo).then(
        (result) => {
          setFooDarklogo(result.data);
          setLoading(false);
        },
        (error) => {}
      );

      /* eslint-disable no-unused-vars */
      /* eslint-disable no-unused-vars */
      const results = await getImagesById(editing.iconLogo).then(
        (result) => {
          setWebicon(result.data);
          setLoading(false);
        },
        (error) => {}
      );
      /* eslint-disable no-unused-vars */

      /* eslint-disable no-unused-vars */
      /* eslint-disable no-unused-vars */
      const res = await getImagesById(editing.tvLogo).then(
        (result) => {
          setTlogo(result.data);
          setLoading(false);
        },
        (error) => {}
      );
      const dres = await getImagesById(editing.tvDarkLogo).then(
        (result) => {
          setTDarklogo(result.data);
          setLoading(false);
        },
        (error) => {}
      );
      /* eslint-disable no-unused-vars */

      /* eslint-disable no-unused-vars */
      const rest = await getImagesById(editing.appIcon).then(
        (result) => {
          setAppIco(result.data);
          setLoading(false);
        },
        (error) => {}
      );
      /* eslint-disable no-unused-vars */

      /* eslint-disable no-unused-vars */
      const rests = await getImagesById(editing.marketingLogo).then(
        (result) => {
          setMarlogo(result.data);
          setLoading(false);
        },
        (error) => {}
      );
      /* eslint-disable no-unused-vars */

      /* eslint-disable no-unused-vars */
      const pest = await getImagesById(editing.chromeCastLogo).then(
        (result) => {
          setCclogo(result.data);
          setLoading(false);
        },
        (error) => {}
      );
      const dpest = await getImagesById(editing.chromeCastDarkLogo).then(
        (result) => {
          setCcDarklogo(result.data);
          setLoading(false);
        },
        (error) => {}
      );
      /* eslint-disable no-unused-vars */
      /* eslint-disable no-unused-vars */
      const tests = await getImagesById(editing.mobileLogo).then(
        (result) => {
          setMoblogo(result.data);
          setLoading(false);
        },
        (error) => {}
      );
      const dtests = await getImagesById(editing.mobileDarkLogo).then(
        (result) => {
          setMobDarklogo(result.data);
          setLoading(false);
        },
        (error) => {}
      );
      /* eslint-disable no-unused-vars */
    };
    getImage();
    brandingDetail();
  }, []);
  const filterOption = (option, searchText) => {
    if (option.data.name.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  };

  const colorSave = async (event) => {
    event.preventDefault();
    if (brandStatus === 404 || brandCount === "No Branding item Exists") {
      /* eslint-disable no-unused-vars */
      const result = await createBranding(branding).then(
        (result) => {
          toastr.success("Successfully Saved", "Success");
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
        }
      );
      /* eslint-disable no-unused-vars */
    } else {
      /* eslint-disable no-unused-vars */
      const result = await editBranding(branding).then(
        (result) => {
          toastr.success("Successfully Saved", "Success");
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
        }
      );
      /* eslint-disable no-unused-vars */
    }
  };

  const publishBrands = async (event) => {
    if (role.production === true) {
      event.preventDefault();
      const result = await publishBranding().then(
        (result) => {
          toastr.success("Successfully Published", "Success");
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
        }
      );
    } else {
      toastr.error("Preview Environment is off", "Error");
    }
    /* eslint-disable no-unused-vars */
  };

  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3
                    className={
                      lan === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    Branding Schema
                  </h3>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <form onSubmit={colorSave}>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Main application logo"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Main Logo&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Main application logo"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <div className="row">
                            <div
                              className="col-md-8"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <Select
                                name="mainLogo"
                                className="form-control inside-select"
                                filterOption={filterOption}
                                options={allImage}
                                onChange={(value, event) =>
                                  onChangeItem(value, event)
                                }
                              ></Select>

                              <div
                                className="row"
                                style={{
                                  marginTop: "20px",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <div
                                  className="col-md-12"
                                  style={{ marginTop: "20px" }}
                                >
                                  <LabelImage
                                    url={
                                      getAppParams() + mainLogo.images.imagekey
                                    }
                                    name={mainLogo.images.imageName}
                                  ></LabelImage>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <Button
                                variant="light"
                                onClick={() => setModalShow(true)}
                                style={{
                                  width: "100px",
                                  marginTop: "8px",
                                  height: "40px",
                                }}
                              >
                                Upload
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Website or shortcut icon"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Webicon&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Website or shortcut icon"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <div className="row">
                            <div
                              className="col-md-8"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <Select
                                name="iconLogo"
                                className="form-control inside-select"
                                filterOption={filterOption}
                                options={allImage}
                                onChange={(value, event) =>
                                  onChangeItem(value, event)
                                }
                              ></Select>
                              <div
                                className="row"
                                style={{
                                  marginTop: "20px",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <div
                                  className="col-md-12"
                                  style={{ marginTop: "20px" }}
                                >
                                  <LabelImage
                                    url={
                                      getAppParams() + webicon.images.imagekey
                                    }
                                    name={webicon.images.imageName}
                                  ></LabelImage>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <Button
                                variant="light"
                                onClick={() => setModalShow(true)}
                                style={{
                                  width: "100px",
                                  marginTop: "8px",
                                  height: "40px",
                                }}
                              >
                                Upload
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Application logo on dark mode"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Dark/Light Main Logo&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Application logo on dark mode"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <div className="row">
                            <div
                              className="col-md-8"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <Select
                                name="mainDarkLogo"
                                className="form-control inside-select"
                                filterOption={filterOption}
                                options={allImage}
                                onChange={(value, event) =>
                                  onChangeItem(value, event)
                                }
                              ></Select>

                              <div
                                className="row"
                                style={{
                                  marginTop: "20px",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <div
                                  className="col-md-12"
                                  style={{ marginTop: "20px" }}
                                >
                                  <LabelImage
                                    url={
                                      getAppParams() +
                                      mainDarkLogo.images.imagekey
                                    }
                                    name={mainDarkLogo.images.imageName}
                                  ></LabelImage>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <Button
                                variant="light"
                                onClick={() => setModalShow(true)}
                                style={{
                                  width: "100px",
                                  marginTop: "8px",
                                  height: "40px",
                                }}
                              >
                                Upload
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Footer icon in dark mode"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Dark/Light Footer Logo&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Footer icon in dark mode"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <div className="row">
                            <div
                              className="col-md-8"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <Select
                                name="footerDarkLogo"
                                className="form-control inside-select"
                                filterOption={filterOption}
                                options={allImage}
                                onChange={(value, event) =>
                                  onChangeItem(value, event)
                                }
                              ></Select>
                              <div
                                className="row"
                                style={{
                                  marginTop: "20px",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <div
                                  className="col-md-12"
                                  style={{ marginTop: "20px" }}
                                >
                                  <LabelImage
                                    url={
                                      getAppParams() +
                                      fooDarkLogo.images.imagekey
                                    }
                                    name={fooDarkLogo.images.imageName}
                                  ></LabelImage>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <Button
                                variant="light"
                                onClick={() => setModalShow(true)}
                                style={{
                                  width: "100px",
                                  marginTop: "8px",
                                  height: "40px",
                                }}
                              >
                                Upload
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Main icon in footer"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Footer Logo&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Main icon in footer"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <div className="row">
                            <div
                              className="col-md-8"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <Select
                                name="footerLogo"
                                className="form-control inside-select"
                                filterOption={filterOption}
                                options={allImage}
                                onChange={(value, event) =>
                                  onChangeItem(value, event)
                                }
                              ></Select>
                              <div
                                className="row"
                                style={{
                                  marginTop: "20px",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <div
                                  className="col-md-12"
                                  style={{ marginTop: "20px" }}
                                >
                                  <LabelImage
                                    url={
                                      getAppParams() + fooLogo.images.imagekey
                                    }
                                    name={fooLogo.images.imageName}
                                  ></LabelImage>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <Button
                                variant="light"
                                onClick={() => setModalShow(true)}
                                style={{
                                  width: "100px",
                                  marginTop: "8px",
                                  height: "40px",
                                }}
                              >
                                Upload
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Main application icon in android device"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;App Icon&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Main application icon in android device"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <div className="row">
                            <div
                              className="col-md-8"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <Select
                                name="appIcon"
                                className="form-control inside-select"
                                filterOption={filterOption}
                                options={allImage}
                                onChange={(value, event) =>
                                  onChangeItem(value, event)
                                }
                              ></Select>
                              <div
                                className="row"
                                style={{
                                  marginTop: "20px",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <div
                                  className="col-md-12"
                                  style={{ marginTop: "20px" }}
                                >
                                  <LabelImage
                                    url={
                                      getAppParams() + appIco.images.imagekey
                                    }
                                    name={appIco.images.imageName}
                                  ></LabelImage>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <Button
                                variant="light"
                                onClick={() => setModalShow(true)}
                                style={{
                                  width: "100px",
                                  marginTop: "8px",
                                  height: "40px",
                                }}
                              >
                                Upload
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Publish date of the Article"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Marketing Logo&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Publish date of the Article"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <div className="row">
                            <div
                              className="col-md-8"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <Select
                                name="marketingLogo"
                                className="form-control inside-select"
                                filterOption={filterOption}
                                options={allImage}
                                onChange={(value, event) =>
                                  onChangeItem(value, event)
                                }
                              ></Select>
                              <div
                                className="row"
                                style={{
                                  marginTop: "20px",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <div
                                  className="col-md-12"
                                  style={{ marginTop: "20px" }}
                                >
                                  <LabelImage
                                    url={
                                      getAppParams() + marLogo.images.imagekey
                                    }
                                    name={marLogo.images.imageName}
                                  ></LabelImage>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <Button
                                variant="light"
                                onClick={() => setModalShow(true)}
                                style={{
                                  width: "100px",
                                  marginTop: "8px",
                                  height: "40px",
                                }}
                              >
                                Upload
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Application logo in TV devices"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Tv Logo&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Application logo in TV devices"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <div className="row">
                            <div
                              className="col-md-8"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <Select
                                name="tvLogo"
                                className="form-control inside-select"
                                filterOption={filterOption}
                                options={allImage}
                                onChange={(value, event) =>
                                  onChangeItem(value, event)
                                }
                              ></Select>
                              <div
                                className="row"
                                style={{
                                  marginTop: "20px",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <div
                                  className="col-md-12"
                                  style={{ marginTop: "20px" }}
                                >
                                  <LabelImage
                                    url={getAppParams() + tLogo.images.imagekey}
                                    name={tLogo.images.imageName}
                                  ></LabelImage>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <Button
                                variant="light"
                                onClick={() => setModalShow(true)}
                                style={{
                                  width: "100px",
                                  marginTop: "8px",
                                  height: "40px",
                                }}
                              >
                                Upload
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Application logo in Chromecast devices"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Chromecast Logo&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Application logo in Chromecast devices"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <div className="row">
                            <div
                              className="col-md-8"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <Select
                                name="chromeCastLogo"
                                className="form-control inside-select"
                                filterOption={filterOption}
                                options={allImage}
                                onChange={(value, event) =>
                                  onChangeItem(value, event)
                                }
                              ></Select>
                              <div
                                className="row"
                                style={{
                                  marginTop: "20px",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <div
                                  className="col-md-12"
                                  style={{ marginTop: "20px" }}
                                >
                                  <LabelImage
                                    url={
                                      getAppParams() + ccLogo.images.imagekey
                                    }
                                    name={ccLogo.images.imageName}
                                  ></LabelImage>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <Button
                                variant="light"
                                onClick={() => setModalShow(true)}
                                style={{
                                  width: "100px",
                                  marginTop: "8px",
                                  height: "40px",
                                }}
                              >
                                Upload
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Application logo in Mobile devices"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Mobile Logo&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Application logo in Mobile devices"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <div className="row">
                            <div
                              className="col-md-8"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <Select
                                name="mobileLogo"
                                className="form-control inside-select"
                                filterOption={filterOption}
                                options={allImage}
                                onChange={(value, event) =>
                                  onChangeItem(value, event)
                                }
                              ></Select>
                              <div
                                className="row"
                                style={{
                                  marginTop: "20px",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <div
                                  className="col-md-12"
                                  style={{ marginTop: "20px" }}
                                >
                                  <LabelImage
                                    url={
                                      getAppParams() + mobLogo.images.imagekey
                                    }
                                    name={mobLogo.images.imageName}
                                  ></LabelImage>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <Button
                                variant="light"
                                onClick={() => setModalShow(true)}
                                style={{
                                  width: "100px",
                                  marginTop: "8px",
                                  height: "40px",
                                }}
                              >
                                Upload
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>
                            {lan === "rtl" && (
                              <ToolTip
                                info={
                                  "Application logo in Dark or Light mode on TV devices"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Dark/Light Tv Logo&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={
                                  "Application logo in Dark or Light mode on TV devices"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <div className="row">
                            <div
                              className="col-md-8"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <Select
                                name="tvDarkLogo"
                                className="form-control inside-select"
                                filterOption={filterOption}
                                options={allImage}
                                onChange={(value, event) =>
                                  onChangeItem(value, event)
                                }
                              ></Select>
                              <div
                                className="row"
                                style={{
                                  marginTop: "20px",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <div
                                  className="col-md-12"
                                  style={{ marginTop: "20px" }}
                                >
                                  <LabelImage
                                    url={
                                      getAppParams() + tDarkLogo.images.imagekey
                                    }
                                    name={tDarkLogo.images.imageName}
                                  ></LabelImage>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <Button
                                variant="light"
                                onClick={() => setModalShow(true)}
                                style={{
                                  width: "100px",
                                  marginTop: "8px",
                                  height: "40px",
                                }}
                              >
                                Upload
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>
                            {lan === "rtl" && (
                              <ToolTip
                                info={
                                  "Application logo in Dark or Light mode on Chromecast devices"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Chromecast Dark/Light Logo&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={
                                  "Application logo in Dark or Light mode on Chromecast devices"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <div className="row">
                            <div
                              className="col-md-8"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <Select
                                name="chromeCastDarkLogo"
                                className="form-control inside-select"
                                filterOption={filterOption}
                                options={allImage}
                                onChange={(value, event) =>
                                  onChangeItem(value, event)
                                }
                              ></Select>
                              <div
                                className="row"
                                style={{
                                  marginTop: "20px",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <div
                                  className="col-md-12"
                                  style={{ marginTop: "20px" }}
                                >
                                  <LabelImage
                                    url={
                                      getAppParams() +
                                      ccDarkLogo.images.imagekey
                                    }
                                    name={ccDarkLogo.images.imageName}
                                  ></LabelImage>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <Button
                                variant="light"
                                onClick={() => setModalShow(true)}
                                style={{
                                  width: "100px",
                                  marginTop: "8px",
                                  height: "40px",
                                }}
                              >
                                Upload
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>
                            {lan === "rtl" && (
                              <ToolTip
                                info={
                                  "Application logo in Dark or Light mode on Mobile devices"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Mobile Dark/Light Logo&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={
                                  "Application logo in Dark or Light mode on Mobile devices"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <div className="row">
                            <div
                              className="col-md-8"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <Select
                                name="mobileDarkLogo"
                                className="form-control inside-select"
                                filterOption={filterOption}
                                options={allImage}
                                onChange={(value, event) =>
                                  onChangeItem(value, event)
                                }
                              ></Select>
                              <div
                                className="row"
                                style={{
                                  marginTop: "20px",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <div
                                  className="col-md-12"
                                  style={{ marginTop: "20px" }}
                                >
                                  <LabelImage
                                    url={
                                      getAppParams() +
                                      mobDarkLogo.images.imagekey
                                    }
                                    name={mobDarkLogo.images.imageName}
                                  ></LabelImage>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <Button
                                variant="light"
                                onClick={() => setModalShow(true)}
                                style={{
                                  width: "100px",
                                  marginTop: "8px",
                                  height: "40px",
                                }}
                              >
                                Upload
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-12">
                        <div
                          className={
                            lan === "rtl"
                              ? "btn-group btn-group-md float-left"
                              : "btn-group btn-group-md float-right"
                          }
                          role="group"
                        >
                          <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ width: "100px", marginRight: "6px" }}
                          >
                            Save
                          </button>
                          <button
                            type="button"
                            onClick={publishBrands}
                            className="btn btn-success"
                            style={{ width: "100px", marginRight: "6px" }}
                            disabled={!role.production === true ? true : false}
                            hidden={!role.production === true ? true : false}
                          >
                            Publish
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>
        <MyVerticallyCenteredModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          allimage={allImage}
        />
      </section>
    );
  }
};

export default Branding;
